"use client";

import { c as _c } from "react/compiler-runtime";
import { useAction } from "next-safe-action/hooks";
import { useRef, useState } from "react";
import { toast } from "sonner";
import { AssignToPopover } from "@/components/issue/assign-to-popover";
import { useCurrentUser } from "@/lib/auth/client";
import { Button } from "@/components/ui/button";
import { updateIssueAction } from "@/actions/update-issue";
export const Assignee = t0 => {
  const $ = _c(12);
  const {
    issue,
    users,
    disabled: t1
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const currentUser = useCurrentUser();
  const prevValue = useRef(issue.assignee ?? null);
  const [assignee, setAssignee] = useState(issue.assignee ?? null);
  const {
    executeAsync,
    isPending
  } = useAction(updateIssueAction);
  let t2;
  if ($[0] !== assignee || $[1] !== currentUser?.id || $[2] !== executeAsync || $[3] !== issue.id || $[4] !== issue.project.id || $[5] !== issue.slug) {
    t2 = async user => {
      prevValue.current = assignee;
      setAssignee(user);
      const result = await executeAsync({
        issueId: issue.id,
        issueSlug: issue.slug,
        projectId: issue.project.id,
        data: {
          assigneeId: user?.id ?? null,
          assignedBy: currentUser?.id ?? undefined
        }
      });
      if (!result) {
        return;
      }
      if (result.serverError) {
        toast.error("Failed to update issue assignee");
        setAssignee(prevValue.current);
        return;
      }
      if (result.data.success) {
        prevValue.current = assignee;
      }
    };
    $[0] = assignee;
    $[1] = currentUser?.id;
    $[2] = executeAsync;
    $[3] = issue.id;
    $[4] = issue.project.id;
    $[5] = issue.slug;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const onAssigneeChange = t2;
  const t3 = Boolean(isPending || disabled);
  let t4;
  if ($[7] !== assignee || $[8] !== onAssigneeChange || $[9] !== t3 || $[10] !== users) {
    t4 = <AssignToPopover users={users} assignee={assignee} onAssigneeChange={onAssigneeChange} disabled={t3} />;
    $[7] = assignee;
    $[8] = onAssigneeChange;
    $[9] = t3;
    $[10] = users;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
export const IssueAssigneeSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex items-center gap-2 rounded bg-slate-3 px-4 py-[1px]"><div className="flex items-center gap-2">Assignee:<span className="h-6 w-28 animate-pulse rounded-lg bg-slate-4" /></div><Button variant="link" className="px-0 underline hover:decoration-2 active:decoration-2 active:underline-offset-[6px]" disabled={true}>change</Button></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};